import React from 'react'
import Fade from 'react-reveal/Fade'

import Video from './video'

const VideoBlock = ({ title, video }) => {

  return (
    <section className='video-block'>
      <Fade bottom distance={'40px'}>
        <div className='video-block__inner'>
          <h2>{title}</h2>
          <Video video={video} />
        </div>
      </Fade>
    </section>
  )
}

export default VideoBlock